<template>
  <div style="width:100%">
    <v-layout
      rows
      wrap
      align-start
    >
      <v-flex xs9>
        <h1>Google Meetings</h1>
      </v-flex>
    </v-layout>
    <v-row v-if="user.isAdmin">
      <v-col cols="4">
        <v-text-field
          v-model="params.searchText"
          label="Solo"
          placeholder="Meet Code / Link / Username @townsendharris.org"
          solo
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-btn
          dark
          :loading="searching"
          color="teal"
          @click="search(0)"
        >today</v-btn>
        <v-btn
          dark
          v-show="!searching"
          color="teal"
          class="ml-5"
          @click="search(7)"
        >last 7 days</v-btn>

      </v-col>
    </v-row>
    <v-layout>
      <v-flex xs12>
        <v-data-table
          :headers="table.headers"
          :items="items"
          :dense="true"
          :search="table.search"
          :sort-by="['time']"
          :sort-desc="true"
          :hide-default-footer="true"
          :disable-pagination="true"
        >
        <template v-slot:item="props">
          <tr>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.start_time | moment("YYYY-MM-DD ddd") }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              <v-btn text @click="viewDetails(props.item)">
              {{ props.item.meeting_code }}
              </v-btn>
            </td>
            <td  style="font-size:.8em" class="text-xs">
              {{ props.item.num_attendees }}
            </td>
            <td  style="font-size:.8em" class="text-xs-left">
              {{ props.item.organizer_email }}
            </td>
            <td style="font-size:.8em" class="text-xs-right">
              {{ props.item.start_time | moment("h:mma") }}
            </td>
            <td style="font-size:.8em">
              {{ props.item.end_time | moment("h:mma") }}
            </td>
            <td style="font-size:.8em" class="text-xs-left">
              {{ props.item.duration_seconds * 1000 | duration('humanize') }}
            </td>
            <td class="text-xs-center">
            </td>
          </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="meetModal"
    >
      <v-card v-if="selected">
        <v-app-bar
              dark
              color="blue"
            >
              <v-toolbar-title>{{ selected.meeting_code }} Attendees</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                style="float:right"
                @click="closeModal"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-app-bar>
        <v-card-text>
          <v-data-table
            :headers="detailHeaders"
            :items="selected.activities"
            :dense="true"
            :sort-by="['start_time']"
            :sort-desc="true"
            :hide-default-footer="true"
            :disable-pagination="true"
          >
          <template v-slot:item="props">
            <tr>
              <td style="font-size:.8em" class="text-xs">
                {{ props.item.start_time | moment("YYYY-MM-DD ddd") }}
              </td>
              <td style="font-size:.8em" class="text-xs">
                {{ props.item.meeting_code }}
              </td>
              <td  style="font-size:.8em" class="text-xs">
                {{ props.item.identifier }}
              </td>
              <td  style="font-size:.8em" class="text-xs-left">
                {{ props.item.organizer_email }}
              </td>
              <td style="font-size:.8em" class="text-xs-right">
                {{ new Date(props.item.start_time) }}
              </td>
              <td style="font-size:.8em">
                {{ new Date(props.item.end_time) }}
              </td>
              <td style="font-size:.8em" class="text-xs-left">
                {{ props.item.duration_seconds * 1000 | duration('humanize') }}
              </td>
            </tr>
            </template>
          </v-data-table>
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')

function sanitize(s) {
  return s.replace(/[^a-z]/gi, '');
}

export default {
  props: ['meetCode'],
  data: () => ({
    user: fb.session.user,
    searching: false,
    meetModal: false,
    selected: null,
    params: {
      searchText: '',
      lookback: 0
    },
    items: [],
    table: {
      search: '',
      headers: [
        { text: 'Date', value: 'time' },
        { text: 'Meeting Code', value: 'meeting_code' },
        { text: 'Num Persons', value: 'num_attendees' },
        { text: 'Host', value: 'organizer_email' },
        { text: 'Start Time', value: 'start_time' },
        { text: 'End Time', value: 'end_time' },
        { text: 'Duration', value: 'duration_seconds' },
        { text: ''}
      ]
    },
    detailHeaders:[
        { text: 'Date', value: 'time' },
        { text: 'Meeting Code', value: 'meeting_code' },
        { text: 'Attendee Id', value: 'identifier' },
        { text: 'Host', value: 'organizer_email' },
        { text: 'Start Time', value: 'start_time' },
        { text: 'End Time', value: 'end_time' },
        { text: 'Duration', value: 'duration_seconds' },
      ]
  }),
  mounted () {
    // this.searchByStudent()
  },
  methods: {
    search: function (lookback) {
      var self = this
      this.params.lookback = lookback
      self.searching = true
      if (this.params.searchText.length > 2 ) {
        if (this.params.searchText.indexOf('@townsendharris') !== -1) {
          self.searchByStudent()
        } else if (this.params.searchText.toUpperCase().indexOf('MEET.GOOGLE') !== -1 ) {
          self.searchByMeetCode()
        } else if (this.params.searchText.toUpperCase().indexOf('-') !== -1 ) {
          self.searchByMeetCode()
        } else {
          api.get('search', { searchText: this.params.searchText, types: ['STUDENTS', 'TEACHERS'] }, (data) => {
            console.log(data)
            if (data.teachers.length > 0 || data.students.length > 0) {
                self.searchByStudent()
            } else {
              self.searchByMeetCode()
            }
          })
        }
      } else {
        self.searchByMeetCode()
      }
    },
    searchByStudent: function () {
      var self = this
      self.items = []
      api.get('getMeetings', { userKey: self.params.searchText.toLowerCase(), lookback: self.params.lookback}, (data) => {
        self.processResults(data)
      })
    },
    searchByMeetCode: function () {
      var self = this
      // this.params.meetCode =

      var meetCode = this.params.searchText.toUpperCase()
      if (meetCode.length > 0) {
        if (meetCode.indexOf("MEET.GOOGLE.COM/LOOKUP/") != -1) {
          meetCode = meetCode.split("LOOKUP/")[1].split("?")[0]
        }
        meetCode = sanitize(meetCode)
      }
      self.params.searchText = meetCode
      self.items = []
      api.get('getMeetings', { meetCode: self.params.searchText, lookback: self.params.lookback }, (data) => {
        self.processResults(data)
      })
    },
    processResults: function (data){
      var self = this
      console.log(data)
      self.searching = false
      data.forEach((meet, i) => {
        if (meet.attendees.length > 1) {
          if (!meet.host) {
            meet.host = meet.activities[0]
            meet.activities.forEach((activity, i) => {
              if (activity.start_time < meet.host.start_time) {
                meet.host.start_time = activity.start_time
                meet.host.start_time_string = activity.start_time_string
              }
              if (activity.end_time > meet.host.end_time) {
                meet.host.end_time = activity.end_time
                meet.host.end_time_string = activity.end_time_string
              }
            });
            meet.host.duration_seconds = ( meet.host.end_time - meet.host.start_time ) / 1000
          }
          meet.meeting_code = meet.host.meeting_code
          meet.duration_seconds = meet.host.duration_seconds
          meet.organizer_email = meet.host.organizer_email
          meet.start_time = meet.host.start_time
          meet.end_time = meet.host.end_time
          meet.num_attendees = meet.attendees.length
          self.items.push(meet)
        }
      });
    },
    closeModal () {
      this.meetModal = false
      this.selected = null
    },
    viewDetails: function (meet) {
      var self = this
      self.selected = meet
      self.meetModal = true
      console.log(self.selected)
    }
  }
}
</script>
